export default __webpack_public_path__ + "static/media/selected-plan-icon.a00cf861.svg";